import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BaseComponent } from '@ridango/core';
import { ModalController } from '@ionic/angular';
import { FavoritesFacade, FavoriteLocation } from '@ridango/components';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'rwidget-add-favorite-location',
    templateUrl: './add-favorite-location-modal.component.html',
    styleUrls: ['./add-favorite-location-modal.component.scss']
})
export class AddFavoriteLocationModalComponent extends BaseComponent implements OnInit, OnDestroy {
    form: FormGroup;
    isShowError = false;
    maxLength = 120;
    @Input() location: FavoriteLocation;

    constructor(
        private modalCtrl: ModalController,
        private favoritesFacade: FavoritesFacade
    ) {
        super();
    }

    ngOnInit(): void {
        this.form = new FormGroup({
            name: new FormControl(this.location.name, [Validators.required, Validators.maxLength(this.maxLength)])
        });
    }

    async cancel(): Promise<void> {
        await this.modalCtrl.dismiss(null, 'cancel');
    }

    async submit() {
        this.isShowError = !this.form.valid;

        if (this.form.valid) {
            this.favoritesFacade.addFavoriteLocation({
                ...this.location,
                name: this.form.get('name').value
            });

            await this.modalCtrl.dismiss(this.form.get('name').value, 'cancel');
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
